window.addEventListener("load", function () {
    $(".ajax-blur-validate").on("blur", function () {
        validateField($(this));
    });

    $("#registerForm").on("submit", async function (e) {
        e.preventDefault();

        $(".error-message").html("");

        let url = $(this).attr("action");
        let formData = $(this).serializeArray();
        $(this)
            .find(
                'input[type="checkbox"]:not(.form-array input[type="checkbox"]):not(:checked)'
            )
            .each(function (i, e) {
                formData.push({ name: e.getAttribute("name"), value: 0 });
            });

        $(this)
            .find(".form-array")
            .each(function (i, element) {
                let value = $(this)
                    .find('input[type="checkbox"]')
                    .filter(function (i, innerElement) {
                        return innerElement.checked;
                    })
                    .map(function (i, innerElement) {
                        return innerElement.getAttribute("value");
                    })
                    .toArray();

                formData.push({
                    name: element.getAttribute("data-name"),
                    value: value,
                });
            });

        if (window.captchaSiteKey != undefined) {
            let token = await window.grecaptcha.execute(window.captchaSiteKey, {
                action: "register",
            });
            formData.push({
                name: "g-recaptcha-response",
                value: token,
            });
        }

        let successCallback = function (data) {
            let parent = $("#registerForm").parent();
            parent.append(data);

            $("#onboardingStepper").remove();
            $("#registerForm").remove();
        };
        let errorCallback = function (key, value) {
            if (key == "g-recaptcha-response") {
                let texts = value.toString().split("|");

                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: texts[0],
                    text: texts[1],
                    showConfirmButton: false,
                });
                return;
            }

            $(`input[name="${key}"]`).removeClass("is-valid");
            $(`input[name="${key}"]`).addClass("is-invalid");

            $(`.error-${key}`).html(value.join(" "));
            $(`.error-${key}`).removeClass("d-none");
        };
        let enableLoadingIndicator = true;

        window.ajaxCall(
            url,
            formData,
            successCallback,
            errorCallback,
            enableLoadingIndicator
        );
    });

    if ($("#registerForm").length > 0) {
        initialValidate();
    }
});

function validateField(field) {
    let self = field;

    var value = self.val();
    if (!value) {
        value = "";
    }

    let form = self.closest("form");

    let url = form.attr("validate-action");
    let formData = [
        {
            name: self.attr("name"),
            value: value,
        },
    ];

    var names = [];
    formData.forEach((element) => {
        if (element["name"] != "_token") {
            names.push(element["name"]);
        }
    });

    let successCallback = function () {
        names.forEach((name) => {
            $(`input[name="${name}"]`).removeClass("is-invalid");
            $(`input[name="${name}"]`).addClass("is-valid");

            $(`.error-${name}`).html("");
            if (!$(`.error-${name}`).hasClass("d-none")) {
                $(`.error-${name}`).addClass("d-none");
            }
        });
    };
    let errorCallback = function (key, value) {
        $(`input[name="${key}"]`).removeClass("is-valid");
        $(`input[name="${key}"]`).addClass("is-invalid");

        $(`.error-${key}`).html(value.join(" "));
        $(`.error-${key}`).removeClass("d-none");
    };

    window.ajaxCall(url, formData, successCallback, errorCallback);
}

function initialValidate() {
    let url = $("#registerForm").attr("validate-action");

    const formData = $("#registerForm")
        .serializeArray()
        .filter((field) => field["value"].length > 0);

    var names = [];
    formData.forEach((element) => {
        if (element["name"] != "_token") {
            names.push(element["name"]);
        }
    });

    let successCallback = function () {
        names.forEach((name) => {
            $(`input[name="${name}"]`).removeClass("is-invalid");
            $(`input[name="${name}"]`).addClass("is-valid");

            $(`.error-${name}`).html("");
            if (!$(`.error-${name}`).hasClass("d-none")) {
                $(`.error-${name}`).addClass("d-none");
            }
        });
    };
    let errorCallback = function (key, value) {
        $(`input[name="${key}"]`).removeClass("is-valid");
        $(`input[name="${key}"]`).addClass("is-invalid");

        $(`.error-${key}`).html(value.join(" "));
        $(`.error-${key}`).removeClass("d-none");
    };

    window.ajaxCall(url, formData, successCallback, errorCallback);
}
